// Import Components

// Components
import BusinessHours from './Components/BusinessHours';
import BwFilters from './Components/BwFilters';
import BwScrollTabs from "./Components/BwScrollTabs.vue";
import BwScrollTabsContent from "./Components/BwScrollTabsContent.vue";
import BwTable from './Components/BwTable';
import CreateMessage from './Components/CreateMessage';

// Forms
import BWDateTimePicker from './Forms/BwDateTimePicker';
import BwPinInput from './Forms/BwPinInput';
import BwSearchSelect from './Forms/BwSearchSelect';
import BwTimeInput from './Forms/BwTimeInput';
import SaveForm from './Forms/SaveForm';
import CancelForm from './Forms/CancelForm';
import WysiwygInput from './Forms/WysiwygInput';

// Media
import BwImage from "./Media/BwImage";
import PassImage from "./Media/PassImage";

// Passes
import SavingsEditPass from './Passes/Views/Templates/Savings/EditPass';
import CheckInEditPass from './Passes/Views/Templates/CheckIn/EditPass';
import CulinaryEditPass from './Passes/Views/Templates/Culinary/EditPass';
import AdmissionEditPass from './Passes/Views/Templates/Admission/EditPass';
import TastingEditPass from './Passes/Views/Templates/Tasting/EditPass';

import PassAdvancedGamification from './Passes/Components/Advanced/Gamification';
import PassAdvancedInventory from './Passes/Components/Advanced/Inventory';
import PassAdvancedInvites from './Passes/Components/Advanced/Invites';
import PassAdvancedSequences from './Passes/Components/Advanced/Sequences';
import PassAdvancedPlaces from './Passes/Components/Advanced/Places';
import PassAdvancedSubmissions from './Passes/Components/Advanced/Submissions';
import PassAdvancedThings from './Passes/Components/Advanced/Things';
import PassBasicsName from './Passes/Components/Basics/Name';
import PassBasicsDetails from './Passes/Components/Basics/Details';
import PassCustomizationCategories from './Passes/Components/Customization/Categories';
import PassCustomizationCheckout from './Passes/Components/Customization/Checkout';
import PassCustomizationColors from './Passes/Components/Customization/Colors';
import PassCustomizationDescription from './Passes/Components/Customization/Description';
import PassCustomizationFaqs from './Passes/Components/Customization/Faqs';
import PassCustomizationImages from './Passes/Components/Customization/Images';
import PassCustomizationPricing from './Passes/Components/Customization/Pricing';
import PassCustomizationRedemption from './Passes/Components/Customization/Redemption';
import PassSalesDescription from './Passes/Components/Sales/Description';
import PassSalesEmbed from './Passes/Components/Sales/Embed';
import PassSalesHighlights from './Passes/Components/Sales/Highlights';

import PlaceMap from './Places/Components/PlaceMap';

// Management Pages
import Places from './Passes/Components/Advanced/Places';

// Preview
import MobilePassPreview from './Preview/MobilePassPreview';
import MobilePassPreviewModal from './Preview/MobilePassPreviewModal';

// Products
import AdmissionEditProduct from './Products/Views/Templates/Admission/EditProduct';
import CheckInEditProduct from './Products/Views/Templates/CheckIn/EditProduct';
import CouponEditProduct from './Products/Views/Templates/Coupon/EditProduct';
import CulinaryEditProduct from './Products/Views/Templates/Culinary/EditProduct';
import EventTicketEditProduct from './Products/Views/Templates/EventTicket/EditProduct';
import QuizEditProduct from './Products/Views/Templates/Quiz/EditProduct';
import TastingEditProduct from './Products/Views/Templates/Tasting/EditProduct';
import RedeemForm from './Products/Views/Templates/Shared/RedeemForm';
import PricingForm from './Products/Views/Templates/Shared/PricingForm';

// UI
import FormDivider from './UI/Form/FormDivider';
import FormSubsection from './UI/Form/FormSubsection';
import FormTitle from './UI/Form/FormTitle';
import PageHeader from './UI/PageHeader';
import BwModal from './UI/BwModal';
import TabButton from './UI/TabButton';
import UiBox from './UI/UiBox';
import UiBoxStatus from './UI/UiBoxStatus';

// Vuetify
import VTextFieldDetails from './Vuetify/VTextFieldDetails.vue';
import Vue from "vue";


// Create Instances

// Components
window.Vue.component('BusinessHours', BusinessHours);
window.Vue.component('BwFilters', BwFilters);
window.Vue.component('BwScrollTabs', BwScrollTabs);
window.Vue.component('BwScrollTabsContent', BwScrollTabsContent);
window.Vue.component('BwTable', BwTable);
window.Vue.component('CreateMessage', CreateMessage);

// Forms
window.Vue.component('BwDateTimePicker', BWDateTimePicker);
window.Vue.component('BwPinInput', BwPinInput);
window.Vue.component('BwSearchSelect', BwSearchSelect);
window.Vue.component('BwTimeInput', BwTimeInput);
window.Vue.component('SaveForm', SaveForm);
window.Vue.component('CancelForm', CancelForm);
window.Vue.component('WysiwygInput', WysiwygInput);

// Media
window.Vue.component('BwImage', BwImage);
window.Vue.component('PassImage', PassImage);

// Passes
window.Vue.component('SavingsEditPass', SavingsEditPass);
window.Vue.component('CheckInEditPass', CheckInEditPass);
window.Vue.component('CulinaryEditPass', CulinaryEditPass);
window.Vue.component('AdmissionEditPass', AdmissionEditPass);
window.Vue.component('TastingEditPass', TastingEditPass);
window.Vue.component('RedeemForm', RedeemForm);
window.Vue.component('PricingForm', PricingForm);

// Passes NEW
window.Vue.component('PassAdvancedGamification', PassAdvancedGamification);
window.Vue.component('PassAdvancedInventory', PassAdvancedInventory);
window.Vue.component('PassAdvancedInvites', PassAdvancedInvites);
window.Vue.component('PassAdvancedSequences', PassAdvancedSequences);
window.Vue.component('PassAdvancedPlaces', PassAdvancedPlaces);
window.Vue.component('PassAdvancedSubmissions', PassAdvancedSubmissions);
window.Vue.component('PassAdvancedThings', PassAdvancedThings);
window.Vue.component('PassBasicsName', PassBasicsName);
window.Vue.component('PassBasicsDetails', PassBasicsDetails);
window.Vue.component('PassCustomizationCategories', PassCustomizationCategories);
window.Vue.component('PassCustomizationCheckout', PassCustomizationCheckout);
window.Vue.component('PassCustomizationColors', PassCustomizationColors);
window.Vue.component('PassCustomizationImages', PassCustomizationImages);
window.Vue.component('PassCustomizationDescription', PassCustomizationDescription);
window.Vue.component('PassCustomizationFaqs', PassCustomizationFaqs);
window.Vue.component('PassCustomizationImages', PassCustomizationImages);
window.Vue.component('PassCustomizationPricing', PassCustomizationPricing);
window.Vue.component('PassCustomizationRedemption', PassCustomizationRedemption);
window.Vue.component('PassSalesDescription', PassSalesDescription);
window.Vue.component('PassSalesEmbed', PassSalesEmbed);
window.Vue.component('PassSalesHighlights', PassSalesHighlights);

window.Vue.component('PlaceMap', PlaceMap);

// Preview
window.Vue.component('MobilePassPreview', MobilePassPreview);
window.Vue.component('MobilePassPreviewModal', MobilePassPreviewModal);

// Products
window.Vue.component('AdmissionEditProduct', AdmissionEditProduct);
window.Vue.component('CheckInEditProduct', CheckInEditProduct);
window.Vue.component('CouponEditProduct', CouponEditProduct);
window.Vue.component('CulinaryEditProduct', CulinaryEditProduct);
window.Vue.component('EventTicketEditProduct', EventTicketEditProduct);
window.Vue.component('QuizEditProduct', QuizEditProduct);
window.Vue.component('TastingEditProduct', TastingEditProduct);

// UI
// Forms
window.Vue.component('FormDivider', FormDivider);
window.Vue.component('FormSubsection', FormSubsection);
window.Vue.component('FormTitle', FormTitle);
window.Vue.component('PageHeader', PageHeader);

// Layout
window.Vue.component('UiBox', UiBox);
window.Vue.component('UiBoxStatus', UiBoxStatus);

// Notification
window.Vue.component('BwModal', BwModal);

// Misc
window.Vue.component('TabButton', TabButton);

// Vuetify
window.Vue.component('VTextFieldDetails', VTextFieldDetails);

// Pages
window.Vue.component('Places', Places);


const vuetify = window.Vuetify;
Vue.use(window.VueTelInputVuetify, {
	vuetify
});

Vue.use(window.TiptapVuetifyPlugin, {
	vuetify,
	iconsGroup: 'mdi'
});

Vue.use(window.VueGoogleMaps, {
	load: {
		key: Vue.prototype.$publicMapKey,
		libraries: 'places'
	}
});
